module.exports = "/_next/static/images/4c3cdc65cc7040e5a0001ca5f0aa55dc-security-lg.jpg";